import { formatCLP } from "../../lib/api";

/**
 * Monto en pesos tipeado en un input de texto: se muestra con separador de
 * miles ("$171.741") mientras se escribe y se guarda como entero.
 */

/** Texto del input → pesos enteros. Ignora todo lo que no sea dígito
 *  ("$171.741" → 171741; "" → 0). */
export function parsearMontoCLP(texto: string): number {
  const digitos = texto.replace(/\D/g, "");
  if (!digitos) return 0;
  return Number(digitos.slice(0, 13));
}

/** Pesos → texto del input ("$171.741"). */
export function mostrarMontoCLP(valor: number | null | undefined): string {
  const n = Number(valor);
  return formatCLP(Number.isFinite(n) && n > 0 ? Math.trunc(n) : 0);
}
